if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const variantInput = this.form.querySelector('[name=id]');

        if (variantInput) {
          variantInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');

        if (
          document.querySelector('cart-drawer') &&
          this.submitButton
        ) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        /*
         * Check if this product has
         * the Shopify tag: custom-spoke
         */
        this.initCustomSpokeField();
      }

      /*
       * ==========================================
       * CHECK PRODUCT TAG
       * ==========================================
       */

      async initCustomSpokeField() {
        if (!this.submitButton) return;

        /*
         * Don't show in Quick Add popup
         */
        if (this.closest('quick-add-modal')) return;

        /*
         * Only run on actual product pages
         */
        if (!window.location.pathname.includes('/products/')) {
          return;
        }

        try {
          /*
           * Shopify product JSON
           * Example:
           * /products/custom-spoke.js
           */

          const productUrl =
            window.location.pathname.replace(/\/$/, '') + '.js';

          const response = await fetch(productUrl);

          if (!response.ok) return;

          const product = await response.json();

          /*
           * Product tags
           */

          let tags = product.tags || [];

          /*
           * Some Shopify responses may return
           * tags as a comma-separated string.
           */

          if (typeof tags === 'string') {
            tags = tags
              .split(',')
              .map((tag) => tag.trim());
          }

          /*
           * Check for custom-spoke tag
           */

          const isCustomSpoke = tags.some(
            (tag) =>
              String(tag)
                .trim()
                .toLowerCase() === 'custom-spoke'
          );

          if (!isCustomSpoke) return;

          this.createSpokeLengthField();
        } catch (error) {
          console.error(
            'Could not check custom-spoke product tag:',
            error
          );
        }
      }

      /*
       * ==========================================
       * CREATE SPOKE LENGTH FIELD
       * ==========================================
       */

      createSpokeLengthField() {
        /*
         * Prevent duplicate fields
         */

        if (
          this.form.querySelector(
            '[name="properties[Kodara Pikkus]"]'
          )
        ) {
          return;
        }

        const spokeLengthWrapper =
          document.createElement('div');

        spokeLengthWrapper.className =
          'product-form__input spoke-length-field';

        spokeLengthWrapper.style.marginBottom = '1.5rem';

        spokeLengthWrapper.innerHTML = `
          <label
            class="form__label"
            for="custom-spoke-length"
            style="
              display:block;
              margin-bottom:6px;
            "
          >
            Kodara Pikkus (mm)
          </label>

          <input
            type="number"
            id="custom-spoke-length"
            name="properties[Kodara Pikkus]"
            min="80"
            max="305"
            step="1"
            inputmode="numeric"
            placeholder="e.g. 278"
            required
            style="
              width:180px;
              max-width:100%;
              padding:11px 12px;
              font-size:16px;
              border:1px solid rgba(0,0,0,0.5);
              border-radius:4px;
              background:transparent;
            "
          >

          <small
            style="
              display:block;
              margin-top:6px;
              font-size:12px;
            "
          >
            Saadaolevad pikkused: 80–305 mm
          </small>
        `;

        /*
         * Insert before Add to cart button
         */

        this.submitButton.parentNode.insertBefore(
          spokeLengthWrapper,
          this.submitButton
        );
      }

      /*
       * ==========================================
       * ADD TO CART
       * ==========================================
       */

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;

        if (
          this.submitButton.getAttribute('aria-disabled') ===
          'true'
        ) {
          return;
        }

        /*
         * ==========================================
         * SPOKE LENGTH VALIDATION
         * ==========================================
         */

        const spokeLengthInput =
          this.form.querySelector(
            '[name="properties[Spoke length]"]'
          );

        if (spokeLengthInput) {
          const rawValue =
            spokeLengthInput.value.trim();

          const spokeLength =
            Number(rawValue);

          /*
           * Empty
           */

          if (rawValue === '') {
            this.handleErrorMessage(
              'Please enter the spoke length.'
            );

            spokeLengthInput.focus();

            return;
          }

          /*
           * Whole millimetres only
           */

          if (!Number.isInteger(spokeLength)) {
            this.handleErrorMessage(
              'Spoke length must be a whole number in millimetres.'
            );

            spokeLengthInput.focus();

            return;
          }

          /*
           * Minimum
           */

          if (spokeLength < 80) {
            this.handleErrorMessage(
              'Minimum spoke length is 80 mm.'
            );

            spokeLengthInput.focus();

            return;
          }

          /*
           * Maximum
           */

          if (spokeLength > 305) {
            this.handleErrorMessage(
              'Maximum spoke length is 305 mm.'
            );

            spokeLengthInput.focus();

            return;
          }
        }

        /*
         * Clear previous error
         */

        this.handleErrorMessage();

        /*
         * Loading state
         */

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add('loading');

        const spinner =
          this.querySelector(
            '.loading-overlay__spinner'
          );

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        /*
         * Shopify AJAX cart configuration
         */

        const config =
          fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        /*
         * IMPORTANT:
         *
         * This includes:
         * properties[Spoke length]
         *
         * automatically.
         */

        const formData =
          new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(
            document.activeElement
          );
        }

        config.body = formData;

        /*
         * Send product to Shopify cart
         */

        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then(
            (response) =>
              response.json()
          )

          .then((response) => {
            /*
             * Shopify error
             */

            if (response.status) {
              this.handleErrorMessage(
                response.description
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) return;

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              const buttonText =
                this.submitButton.querySelector(
                  'span'
                );

              if (buttonText) {
                buttonText.classList.add(
                  'hidden'
                );
              }

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;

              return;
            }

            /*
             * No cart drawer
             */

            if (!this.cart) {
              window.location =
                window.routes.cart_url;

              return;
            }

            this.error = false;

            /*
             * Quick Add support
             */

            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(
                      response
                    );
                  });
                },
                {
                  once: true
                }
              );

              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(
                response
              );
            }
          })

          .catch((error) => {
            console.error(error);

            this.handleErrorMessage(
              'Something went wrong. Please try again.'
            );
          })

          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            if (spinner) {
              spinner.classList.add(
                'hidden'
              );
            }
          });
      }

      /*
       * ==========================================
       * ERROR MESSAGE
       * ==========================================
       */

      handleErrorMessage(
        errorMessage = false
      ) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        /*
         * Fallback if Ride doesn't have
         * an error-message element
         */

        if (!this.errorMessageWrapper) {
          if (errorMessage) {
            alert(errorMessage);
          }

          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }
    }
  );
}